import { render } from "./addstudent.vue?vue&type=template&id=78e969b1"
import script from "./addstudent.vue?vue&type=script&lang=js"
export * from "./addstudent.vue?vue&type=script&lang=js"

import "./addstudent.vue?vue&type=style&index=0&id=78e969b1&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__